<template>
    <div>
        <div id="cadTemp" class="mb-2">

            <!-- Dados da Operadora -->
            <AzSubTitle title="Dados Pessoais">
                <span v-if="$store.state.user.st_login == 'administrador'">
                    <a href="#" class="card-link" @click.prevent="preencher()" v-shortkey="['ctrl', 'w']" @shortkey="preencher()">
                        <i class="fas fa-paint-brush"></i>
                    </a>
                </span>
            </AzSubTitle>
                        
            <div class="form-row">
                <div class="col col-12 col-md-3" id="campo-cadastro-temporario">
                    <AzInput :edicao="edicao" label="Sexo" 
                        sizing="sm"
                        type="sexo" v-model="value.ch_sexo" 
                        required :validate="validate" />
                </div>
                <div class="col col-12 col-md-3">
                    <az-input :edicao="edicao" label="Data de Nascimento" 
                        sizing="sm"
                        type="date" v-model="value.dt_nascimento" 
                        :validate="validate" :rules="['nasc']">
                        <template v-slot:buttonposb>
                            <div class="input-group-append" v-if="idade || idade === 0">
                                <span class="input-group-text" id="basic-addon2" title="Idade em anos">{{ idade }}a</span>
                            </div>
                        </template>
                    </az-input>
                </div>
                <div class="col col-12 col-md-3">
                    <AzInput :edicao="edicao" label="Telefone" 
                        sizing="sm"
                        type="fone" v-model="value.st_telefone" 
                        :validate="validate" :rules="['fone']" />
                </div>
                <div class="col col-12 col-md-3">
                    <az-input :edicao="edicao" label="Celular" 
                        sizing="sm"
                        :type="value.st_cod_pais == '+' ? 'number' : 'fone'" 
                        v-model="value.st_celular" 
                        :validate="validate" :rules="['fone']">
                        <template v-slot:button-pre>
                            <div class="input-group-prepend">
                                <div class="dropdown">
                                    <button class="btn btn-outline-secondary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <span v-if="value.st_cod_pais == '+'">EX</span>
                                        <span v-else>BR</span>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="#" @click.prevent="value.st_cod_pais = '55'">BR - Número do Brasil</a>
                                        <a class="dropdown-item" href="#" @click.prevent="value.st_cod_pais = '+'">EX - Número do Exterior</a>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </az-input>
                </div>
            </div>

            <div class="form-row">
                <div class="col col-12 col-md-3">
                    <az-input :edicao="edicao" label="e-mail" 
                        sizing="sm"
                        type="email" 
                        v-model="value.st_email" 
                        :required="email_obrig ? true : false"
                        :validate="validate" />
                </div>
                <div class="col col-12 col-md-3">
                    <az-input 
                        :edicao="edicao" 
                        :label="is_vtr ? 'Tutor' : 'Nome Social'" 
                        sizing="sm"
                        v-model="value.st_nome_social" 
                        :validate="validate" />
                </div>
                <div class="col col-12" :class="is_vtr ? 'col-md-6' : 'col-md-4'">
                    <az-input 
                        :edicao="edicao" label="Nome" 
                        sizing="sm"
                        type="text"
                         v-model="value.st_nome" 
                        required 
                        :validate="validate" 
                        @change="trocou_nome"
                        :rules="['nome']"/>
                </div>
                <div class="col col-12 col-md-2" v-if="!is_vtr">
                        <az-input 
                            sizing="sm"
                            :edicao="edicao" 
                            label="CPF"
                            type="cpf"
                            :required="cpf_obrig ? true : false"
                            :validate="validate"
                            v-model="value.st_cpf" />
                    </div>
            </div>

            <template v-if="coletar_matricula && !is_vtr">
                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-input 
                            sizing="sm" 
                            :edicao="edicao" 
                            label="No. da Carteira do Plano"
                            :required="!matricula_opcional"
                            :validate="validate"
                            v-model="value.st_numero_carteira"  />
                    </div>
                    <div class="col col-12 col-md-6">
                        <az-input 
                            sizing="sm"
                            :edicao="edicao" 
                            label="Validade da Carteira"
                            type="date"
                            :required="!matricula_opcional"
                            :validate="validate"
                            v-model="value.dt_validade_carteira" />
                    </div>
                </div>
            </template>

            <template v-if="lista && lista.length > 0">
                <az-sub-title title="Possíveis Cadastros">
                    <i class="fa-solid fa-circle-exclamation text-warning"></i>
                </az-sub-title>
                <div class="list-group">
                    <button type="button" class="list-group-item list-group-item-warning list-group-item-action small" 
                        @click="identificar_paciente(item)"
                        v-for="(item, idx) in achados" :key="idx">
                        <span :class="item.pessoa.st_nome == value.st_nome ? 'font-weight-bold' : ''">{{ item.pessoa.st_nome }}</span>
                        <span :class="item.st_email == value.st_email ? 'font-weight-bold' : ''" v-if="item.st_email">
                            / {{ item.st_email }} 
                        </span>
                        <span :class="( item.telefones.telefone == value.st_celular || item.telefones.telefone == value.st_telefone ) ? 'font-weight-bold' : ''" v-if="item.telefones && item.telefones.telefone">
                            / {{ $util.formatMask(item.telefones.telefone, "tel") }}
                        </span>
                        <span :class="( item.telefones.celular == value.st_celular || item.telefones.celular == value.st_telefone ) ? 'font-weight-bold' : ''" v-if="item.telefones && item.telefones.celular">
                            / {{ $util.formatMask(item.telefones.celular, "tel") }}
                        </span>
                        <span :class="item.st_cpf == value.st_cpf ? 'font-weight-bold' : ''" v-if="item.st_cpf">
                            / CPF: {{ $util.formatMask(item.st_cpf, "cpf") }}
                        </span>
                        <span :class="item.dt_nascimento == value.dt_nascimento ? 'font-weight-bold' : ''" v-if="item.dt_nascimento">
                            / DN: {{ $util.getFormatDate(item.dt_nascimento) }}
                        </span>
                    </button>
                    <li class="list-group-item disabled" v-if="$store.state.loading">
                        <div class="spinner-border spinner-border-sm" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                    </li>
                    <li class="list-group-item disabled" v-else-if="lista && lista.length > 3">
                        ...
                    </li>
                </div>
            </template>

            <template v-if="temps && temps.length > 0">
                <az-sub-title title="Possíveis Marcações Anteriores" />
                <div class="list-group">
                    <button type="button" class="list-group-item list-group-item-action small" 
                        @click="identificar_paciente_temp(temp)"
                        v-for="(temp, idx) in lista_temps" :key="idx">
                        {{ temp.st_nome }} | {{ temp.st_email }} 
                        <span v-if="temp.st_telefone">
                            | {{ $util.formatMask(temp.st_telefone, "tel") }}
                        </span>
                        <span v-if="temp.st_celular">
                            | {{ $util.formatMask(temp.st_celular, "tel") }}
                        </span>
                        <ul class="mb-0">
                            <li v-for="(marc, imx) in temp.marcacoes" :key="imx">
                                {{ $util.getFormatDate(marc.dt_inicio) }}
                                {{ marc.dt_inicio.substr(11,5) }}
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                {{ marc.procedimento.search }}
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                {{ marc.medico.search }}

                                <template v-if="marc.dt_inicio < $util.hoje()">
                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                    Falta
                                </template>
                            </li>
                        </ul>
                    </button>
                    <li class="list-group-item disabled" v-if="$store.state.loading">
                        <div class="spinner-border spinner-border-sm" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                    </li>
                    <li class="list-group-item disabled" v-else-if="temps && temps.length > 3">
                        ...
                    </li>
                </div>
            </template>

        </div>
    </div>
</template>

<script>
import * as moment from "moment";
import AzSubTitle from '../../util/AzSubTitle.vue'
import AzInput from '../../shared/forms/AzInput.vue'

export default {
    data () { 
        return { 
            dados: {},
            edicao: true,
            pesquisa: "",
            search_timeout: null,
            lista: [],
            temps: null, 
        }
    },

    computed: { 
        is_vtr: function () { 
            return this.$store.state.user && this.$store.state.user.vtr;
        },

        achados: function () { 
            if ( !this.lista )
                return [];

            return this.lista.slice(0, 3);
        },

        lista_temps: function () { 
            if ( !this.temps )
                return [];

            return this.temps.slice(0, 3);
        },

        idade: function () { 
            if ( !this.value || !this.value.dt_nascimento )
                return;

            let today = moment();
            let birthdateMoment = moment(this.value.dt_nascimento, 'YYYY-MM-DD');
            
            return today.diff(birthdateMoment, 'years');
        },
    },

    props: ['value', 'validate', 'coletar_matricula', 'matricula_opcional', 'cpf_obrig', 'email_obrig'],

    watch: {
        value: { 
            handler () { 
                this.$emit('input', this.value);

                let cpf = ( this.value.st_cpf && this.value.st_cpf.length == 11 ) ? this.value.st_cpf : '';

                if ( this.value && this.value.ch_sexo && this.value.dt_nascimento && 
                    ( 
                        ( this.value.st_telefone && this.value.st_telefone.length == 10 ) ||
                        ( this.value.st_celular && this.value.st_celular.length == 10 ) 
                    )
                ) { 

                    if ( this.pesquisa != this.value.ch_sexo + '|' + this.value.dt_nascimento + '|' + this.value.st_celular + '|' + this.value.st_telefone + '|' + cpf ) { 

                        this.pesquisa = this.value.ch_sexo + '|' + this.value.dt_nascimento + '|' + this.value.st_celular + '|' + this.value.st_telefone + '|' + cpf;

                        if ( this.search_timeout ) {  
                            clearTimeout(this.search_timeout);
                        }

                        if ( this.$store.state.user && ( this.$store.state.user.st_tipo == 'P' || this.$store.state.user.st_tipo == 'X' ) ) { 
                            return; 
                        }

                        this.search_timeout = setTimeout(() => {
                            this.search_timeout = null;
                            this.$util.loadItem(this, { 
                                service: "pacientes",
                                func: "checar_existencia",
                                parms: { 
                                    ...this.value,
                                    temps: true 
                                },
                            })
                            .then(res => { 
                                this.lista = res ? res.pacientes : [];
                                this.temps = res ? res.temps : [];
                            });
                        }, 300);

                    }

                } else { 

                    this.lista = [];
                    this.temps = [];
                    this.search_timeout = null;

                }
                    
            },
            deep: true,
            immediate: true,
        }
    },

    components: { 
        AzSubTitle,
        AzInput
    },

    methods: { 
        trocou_nome () { 
            this.checar_existencia();
        },

        checar_existencia () { 
            let cpf = ( this.value.st_cpf && this.value.st_cpf.length == 11 ) ? this.value.st_cpf : '';

            if ( this.value && this.value.ch_sexo && this.value.dt_nascimento && 
                ( 
                    ( this.value.st_telefone && this.value.st_telefone.length == 10 ) ||
                    ( this.value.st_celular && this.value.st_celular.length == 10 ) ||
                    ( this.value.st_nome && this.value.st_nome.length > 5 ) 
                )
            ) { 

                if ( this.pesquisa != this.value.ch_sexo + '|' + this.value.dt_nascimento + '|' + this.value.st_celular + '|' + this.value.st_telefone + '|' + cpf + '|' + this.value.st_nome) { 

                    this.pesquisa = this.value.ch_sexo + '|' + this.value.dt_nascimento + '|' + this.value.st_celular + '|' + this.value.st_telefone + '|' + cpf + '|' + this.value.st_nome;

                    if ( this.search_timeout ) {  
                        clearTimeout(this.search_timeout);
                    }

                    if ( this.$store.state.user && ( this.$store.state.user.st_tipo == 'P' || this.$store.state.user.st_tipo == 'X' ) ) { 
                        return; 
                    }

                    this.search_timeout = setTimeout(() => {
                        this.search_timeout = null;
                        this.$util.loadItem(this, { 
                            service: "pacientes",
                            func: "checar_existencia",
                            parms: { 
                                ...this.value,
                                temps: true 
                            },
                        })
                        .then(res => { 
                            this.lista = res ? res.pacientes : [];
                            this.temps = res ? res.temps : [];
                        });
                    }, 300);

                }

            } else { 

                this.lista = [];
                this.temps = [];
                this.search_timeout = null;

            }
        },

        getRandomInt(min, max) {
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min + 1)) + min;
        },   
        getRandomDate(date1, date2) {
            date1 = date1 || '01-01-1970'
            date2 = date2 || new Date().toLocaleDateString()
            date1 = new Date(date1).getTime()
            date2 = new Date(date2).getTime()
            if( date1>date2){
                return new Date(this.getRandomInt(date2,date1)).toISOString();
            } else{
                return new Date(this.getRandomInt(date1, date2)).toISOString();  
            }
        },
        preencher() { 
            this.value.ch_sexo = 'M';
            this.value.st_telefone = '71' + this.getRandomInt(20000000, 39999999);
            this.value.st_celular = '71' + this.getRandomInt(80000000, 99999999);
            this.value.dt_nascimento = this.getRandomDate('1960-01-01', '2001-06-01');

            this.$store.commit("loading", true);

            this.$util.loadItem(this, { 
                service: "pacientes",
                func: "random",
            })
            .then(res => { 
                this.value.st_nome = res.nome;
                this.value.st_email = res.email;
            })
            .finally(() => { 
                this.$store.commit("loading", false);
            })
        },
        identificar_paciente (paciente) { 
            this.$emit('selecionar', paciente.id_pessoa);
        },
        identificar_paciente_temp(temp) { 
            this.value.st_nome = temp.st_nome;

            if ( !this.value.st_email ) { 
                this.value.st_email = temp.st_email;
            }

            if ( !this.value.st_telefone ) { 
                this.value.st_telefone = temp.st_telefone;
            }

            if ( !this.value.st_celular ) { 
                this.value.st_celular = temp.st_celular;
            }

            this.$forceUpdate();
        }
    }
}
</script>